import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { DriverShell } from "@/components/shells";
import { Spinner, Tag, EmptyState } from "@/components/kit";
import { useAsync } from "@/lib/hooks";
import { loadDriverBookings } from "@/lib/driverData";
import { formatReg, fmtDate, REQUEST_LABEL } from "@/lib/vda";

export default function DriverHistory() {
  const { data, loading } = useAsync(() => loadDriverBookings(), []);
  const [tab, setTab] = useState("open");
  if (loading) return <DriverShell back="/driver"><Spinner /></DriverShell>;
  const open = data.filter((b) => b.public_status !== "Completed");
  const done = data.filter((b) => b.public_status === "Completed");
  const list = tab === "open" ? open : done;

  return (
    <DriverShell back="/driver" title="Request history">
      <div className="flex gap-2 mb-4">
        {[["open", `Open (${open.length})`], ["completed", `Completed (${done.length})`]].map(([k, label]) => (
          <button key={k} data-testid={`history-tab-${k}`} onClick={() => setTab(k)}
            className={`h-9 px-4 text-sm rounded-[3px] border ${tab === k ? "bg-primary text-primary-foreground border-primary" : "border-[hsl(var(--input))]"}`}>
            {label}
          </button>
        ))}
      </div>
      {list.length === 0 ? (
        <EmptyState title="Nothing here yet" hint={tab === "open" ? "You have no open requests." : "No completed requests."} />
      ) : (
        <div className="space-y-2">
          {list.map((b) => (
            <Link key={b.id} to={`/driver/booking/${b.id}`} data-testid={`history-row-${b.human_reference}`}
              className="vda-panel p-4 flex items-center justify-between hover:border-primary transition-colors">
              <div>
                <div className="flex items-center gap-2">
                  <span className="vda-reg text-xs text-muted-foreground">{b.human_reference}</span>
                  <span className="vda-reg text-xs">{formatReg(b.registration)}</span>
                </div>
                <div className="font-medium text-sm mt-1">{REQUEST_LABEL[b.request_type] || b.request_type}</div>
                <div className="text-xs text-muted-foreground mt-0.5">Appt: {fmtDate(b.appointment_at)}</div>
              </div>
              <div className="flex items-center gap-2">
                <Tag tone={b.public_status === "Completed" ? "muted" : "green"}>{b.public_status}</Tag>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </DriverShell>
  );
}
